import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, makeStyles, Typography, Grid, TextField, Button, Paper, Tabs, Tab, CircularProgress, InputAdornment } from '@material-ui/core';
import { API, graphqlOperation } from 'aws-amplify';
import React, { useEffect, useRef, useState } from 'react';
import { Pagination } from '@material-ui/lab';
import { ButtonTemplate } from '../../components/button/button-template';
import MessageDialog from '../../components/dialog/message-dialog';
import { pluralize } from '../../lib/utils';
import { ListSubHistoryAdmin } from '../../lib/graphql-command/command';
import moment from 'moment';
import { CancelSubscriptionDialog } from '../../components/subscription-history/cancel-subscription-dialog';
import CloseIcon from '@material-ui/icons/Close';

const useStyle = makeStyles(theme => ({
    table: {
        border: '1px solid #d4d4d4',
        '& .MuiTableCell-head': {
            fontWeight: 'bold'
        }
    },
    date: {
        whiteSpace: 'break-spaces'
    },
    links: {
        display: 'none',
        minHeight: '5px',
        '& a': {
            marginRight: '5px',
            textDecoration: 'none',
            fontSize: '0.9rem'
        }
    },
    trash: {
        color: '#a00'
    },
    row: {
        verticalAlign: 'top',
        '&:hover': {
            '& .MuiBox-root': {
                display: 'block'
            }
        }
    },
    searchBtn: {
        borderRadius: '50px',
        marginLeft: '10px'
	},
	videoTitle: {
		width: '40%'
	},
	image: {
		width: '60px',
		height: '60px',
		objectFit: 'cover'
	},
	link: {
		textDecoration: 'none'
	},
	avatar: {
		width: '60px',
		height: '60px',
		objectFit: 'cover'
	},
	username: {
		verticalAlign: 'top'
    },
    loading: {
        opacity: '0.5',
        pointerEvents: 'none',
        position: 'relative'
    },
    loadingIcon: {
        position: 'absolute',
        top: '50%',
        left: '50%'
    },
    textIcon: {
        cursor: 'pointer'
    }
}))

const SubscriptionHistory = () => {
    const classes = useStyle();
    const [subscriptions, setSubscriptions] = useState();
    const [cancelSubscription, setCancelSubscribtion] = useState()
    const [openCancelDialog, setOpenCancelDialog] = useState(false);
    const [messageDialog, setMessageDialog] = useState();
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState({FilterText: ''});
    const [page, setPage] = useState(1)
    const searchRef = useRef();
    const pageSize = 50

    useEffect(() => {
        getListSub();
    }, [page, search])

    const getListSub = () => {
        setLoading(true)
        API.graphql(graphqlOperation(ListSubHistoryAdmin, {
            Page: page,
            NumberItem: pageSize,
            FilterEmail: search.FilterText,
        }))
        .then(result => {
            setSubscriptions(result.data.listSubHistoryAdmin)
            setLoading(false)
        })
        .catch(err => console.log(err))
    }

    const handleSearch = () => {
        setPage(1)
        setSearch({
			FilterText: searchRef.current.value || ''
		})
	}

	const handleCancel = (subscription) => {
		setCancelSubscribtion(subscription)
		setOpenCancelDialog(true)
	}

    const pageCount = () => {
        return Math.ceil((subscriptions?.CountAll||0)/pageSize)
    }

    console.log(subscriptions)
    return (
        <Box>
            <Typography variant='h4'>Subscription History</Typography>
			<Box py={10}>
				<Grid container justify='flex-end' spacing={10}>
					<Grid item>
						<Box>
							<TextField variant='outlined'
                                size='small'
                                placeholder='Email'
                                inputRef={searchRef}
                                onKeyDown={e => {
                                    if (e.keyCode === 13) {
                                        handleSearch();
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment
                                            position="end"
                                            className={classes.textIcon}
                                            onClick={e => {
                                                searchRef.current.value = ''
                                                handleSearch()
                                            }}
                                        >
                                            <CloseIcon />
                                        </InputAdornment>
                                    ),
                                }}
							/>
							<ButtonTemplate variant='contained'
								color='primary'
								borderradius='50px'
								margin='0 0 0 10px'
								onClick={handleSearch}
							>Search</ButtonTemplate>
						</Box>
					</Grid>
				</Grid>
			</Box>
            <Box className={loading ? classes.loading : ''}>
                {loading && <Box className={classes.loadingIcon}><CircularProgress size={40} /></Box>}
                {subscriptions?.Items?.length > 0 && <TableContainer className={classes.table}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Serial No</TableCell>
                                <TableCell>Order ID</TableCell>
                                <TableCell>Subscription ID</TableCell>
                                <TableCell>User Email</TableCell>
                                <TableCell>Plan</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Created Date</TableCell>
                                <TableCell>Action</TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {subscriptions?.Items?.map((sub, index) => (
                                <TableRow key={sub.OrderID} className={classes.row}>
                                    <TableCell>{pageSize * (page-1) + index + 1}</TableCell>
                                    <TableCell>{sub.OrderCode}</TableCell>
                                    <TableCell>{sub.SubscriptionID}</TableCell>
                                    <TableCell>{sub.Email}</TableCell>
                                    <TableCell>{sub.Name}</TableCell>
                                    <TableCell>{sub.Amount}</TableCell>
                                    <TableCell>{moment(sub.CreatedAt).format('DD MMM, YYYY')}</TableCell>
                                    <TableCell>
                                        <ButtonTemplate
                                            variant='contained'
                                            color='primary'
                                            size='small'
                                            changetextcolor='#fff'
                                            borderradius='5px'
                                            onClick={() => handleCancel(sub)}
                                        >Cancel</ButtonTemplate>
                                    </TableCell>
                                    <TableCell>{sub.Status === 1 ? 'Completed' : 'Canceled'}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>}
            </Box>
            {subscriptions?.Items?.length <= 0 && <Box>
                Subscription history not found!
            </Box>}
            {subscriptions?.CountAll > 0 && <Box py={10}>
                <Grid container>
                    <Grid item>
                        {pluralize(subscriptions?.CountAll, 'subscription', 'subscriptions')}
                    </Grid>
                    <Grid item>
                        {pageCount() > 1 && <Box pb={10}>
                            <Pagination count={pageCount()} onChange={(e, value) => setPage(value)} page={page} color="primary"/>
                        </Box>}
                    </Grid>
                </Grid>
            </Box>}
            <CancelSubscriptionDialog {...{open: openCancelDialog, setOpen: setOpenCancelDialog, subscription: cancelSubscription, getListSub, setMessageDialog}} />
            <MessageDialog {...{message: messageDialog, setMessage: setMessageDialog}} />
      </Box>
    )
}

export default SubscriptionHistory;